import { Icon, TextLink } from "@abb/arcadia-ui-react"
import { useCallback } from "react"
import { copyToClipboard } from "../../../../utils/copyToClipboard"
import { useNavigate } from "react-router-dom"
import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../models/Authorization"
import { RoleRequestGet } from "../../../../models/RoleRequest"
import { UserInfo } from "../../../../models/User"

export function RoleRequestRequestor(props: {
  readonly roleRequest: RoleRequestGet
  readonly user: UserInfo
}) {
  const { roleRequest, user } = props

  const navigate = useNavigate()
  const copyToClipboardEmail = useCallback(() => {
    copyToClipboard(roleRequest.user.username)
  }, [roleRequest.user.username])

  const handleSeeRolesClick = useCallback(
    () => navigate(`/users/${roleRequest.user.id}#apps-roles`),
    [navigate, roleRequest.user.id]
  )

  const detailsContentProps: DiMaDetailsContentProps = {
    listItems: [
      {
        id: 0,
        label: "First name",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.user.first}</div>,
      },
      {
        id: 1,
        label: "Last name",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.user.last}</div>,
      },
      {
        id: 2,
        label: "Email address",
        displayItem: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span style={{ textTransform: "none" }}>{roleRequest.user.username}</span>
              <Icon
                iconName="icon_abb_dias icon-abb_copy-1"
                size={24}
                onClick={copyToClipboardEmail}
              />
            </div>
            {hasUserAccessToApplicationFeature(
              user.authorizations.applications,
              roleRequest.application.id,
              DimaFeatureShortNameEnum.RM,
              AccessLevel.Read
            ) && (
              <TextLink
                onClick={handleSeeRolesClick}
                size={14}
                text="See current roles"
              />
            )}
          </div>
        ),
      },
      {
        id: 3,
        label: "Country",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.country}</div>,
      },
      {
        id: 4,
        label: "Address",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.address}</div>,
      },
      {
        id: 5,
        label: "Company",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.company}</div>,
      },
      {
        id: 6,
        label: "Department",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.department}</div>,
      },
      {
        id: 7,
        label: "Phone",
        displayItem: <div style={{ width: "100%" }}>{roleRequest.phone}</div>,
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
